<template>
  <header class="header" :class="{ 'dark-mode': isDarkMode }">
    <div class="logo-container">
      <router-link to="/" class="logo">
        <span class="logo-text">抖音SEO教学</span>
      </router-link>
    </div>
    
    <!-- 桌面端导航 -->
    <div class="nav-container desktop-only">
      <el-menu
        :default-active="activeIndex"
        class="nav-menu"
        mode="horizontal"
        :background-color="isDarkMode ? '#1a1a2e' : '#fff'"
        :text-color="isDarkMode ? '#f0f0f0' : '#333'"
        :active-text-color="'#7957d5'"
        router
      >
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/theory/intro">理论学习</el-menu-item>
        <el-menu-item index="/practice/account">实战指导</el-menu-item>
        <el-menu-item index="/tools">工具箱</el-menu-item>
        <el-menu-item index="/cases">成功案例</el-menu-item>
      </el-menu>
    </div>
    
    <!-- 移动端汉堡菜单按钮 -->
    <div class="mobile-menu-button mobile-only" @click="toggleMobileMenu">
      <i :class="mobileMenuVisible ? 'el-icon-close' : 'el-icon-s-fold'"></i>
    </div>
    
    <div class="user-actions">
      <el-tooltip content="切换主题" placement="bottom">
        <el-button 
          type="text" 
          @click="toggleTheme" 
          :icon="isDarkMode ? 'el-icon-sunny' : 'el-icon-moon'"
          class="theme-toggle"
        ></el-button>
      </el-tooltip>
      <el-progress 
        type="circle" 
        :percentage="Math.floor(overallProgress * 100)" 
        :width="40"
        :stroke-width="4"
        :color="progressColor"
        class="progress-indicator desktop-only"
      ></el-progress>
    </div>
    
    <!-- 移动端菜单抽屉 -->
    <div class="mobile-menu" v-show="mobileMenuVisible" :class="{ 'show': mobileMenuVisible, 'dark-mode': isDarkMode }">
      <el-menu
        :default-active="activeIndex"
        class="mobile-nav-menu"
        :background-color="isDarkMode ? '#1a1a2e' : '#fff'"
        :text-color="isDarkMode ? '#f0f0f0' : '#333'"
        :active-text-color="'#7957d5'"
        router
        @select="handleMobileMenuSelect"
      >
        <el-menu-item index="/">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/theory/intro">
          <i class="el-icon-reading"></i>
          <span>理论学习</span>
        </el-menu-item>
        <el-menu-item index="/practice/account">
          <i class="el-icon-s-cooperation"></i>
          <span>实战指导</span>
        </el-menu-item>
        <el-menu-item index="/tools">
          <i class="el-icon-s-tools"></i>
          <span>工具箱</span>
        </el-menu-item>
        <el-menu-item index="/cases">
          <i class="el-icon-s-management"></i>
          <span>成功案例</span>
        </el-menu-item>
      </el-menu>
      
      <div class="mobile-progress-section">
        <h3 class="mobile-progress-title">学习进度</h3>
        <el-progress 
          :percentage="Math.floor(overallProgress * 100)" 
          :stroke-width="10"
          :color="progressColor"
          class="mobile-progress-bar"
        ></el-progress>
        <div class="mobile-progress-value">{{ Math.floor(overallProgress * 100) }}%</div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SiteHeader',
  data() {
    return {
      mobileMenuVisible: false
    }
  },
  computed: {
    ...mapGetters(['isDarkMode', 'getOverallProgress']),
    activeIndex() {
      return this.$route.path
    },
    overallProgress() {
      return this.getOverallProgress
    },
    progressColor() {
      return [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f42c1', percentage: 100}
      ]
    }
  },
  methods: {
    ...mapActions(['toggleTheme']),
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      // 当菜单打开时，禁止背景滚动
      document.body.style.overflow = this.mobileMenuVisible ? 'hidden' : '';
    },
    handleMobileMenuSelect() {
      // 选择菜单项后关闭菜单
      this.mobileMenuVisible = false;
      document.body.style.overflow = '';
    }
  },
  // 监听路由变化，关闭移动菜单
  watch: {
    '$route'() {
      this.mobileMenuVisible = false;
      document.body.style.overflow = '';
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 100;
  transition: all 0.3s ease;
}

.dark-mode.header {
  background-color: #1a1a2e;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.logo-container {
  margin-right: 20px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  background: linear-gradient(45deg, #7957d5, #3273dc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: 10px;
}

.nav-container {
  flex: 1;
}

.nav-menu {
  border-bottom: none !important;
  background-color: transparent !important;
}

.user-actions {
  display: flex;
  align-items: center;
}

.theme-toggle {
  font-size: 20px;
  margin-right: 15px;
  color: #7957d5;
}

.progress-indicator {
  margin-left: 10px;
}

/* 移动端样式 */
.mobile-menu-button {
  display: none;
  font-size: 24px;
  color: #7957d5;
  cursor: pointer;
  margin-left: auto;
  margin-right: 15px;
}

.mobile-menu {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  height: calc(100vh - 60px);
  background-color: #fff;
  z-index: 99;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  padding: 20px 0;
}

.mobile-menu.dark-mode {
  background-color: #1a1a2e;
}

.mobile-menu.show {
  transform: translateX(0);
}

.mobile-nav-menu {
  border-right: none !important;
}

.mobile-nav-menu .el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
}

.mobile-nav-menu .el-menu-item i {
  margin-right: 10px;
  font-size: 18px;
}

.mobile-progress-section {
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.dark-mode .mobile-progress-section {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-progress-title {
  font-size: 16px;
  margin-bottom: 15px;
  color: #7957d5;
}

.mobile-progress-bar {
  margin-bottom: 10px;
}

.mobile-progress-value {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #7957d5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  
  .mobile-only {
    display: block !important;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .header {
    padding: 0 15px;
  }
  
  .theme-toggle {
    font-size: 22px;
    margin-right: 0;
  }
}

@media (min-width: 769px) {
  .desktop-only {
    display: block !important;
  }
  
  .mobile-only {
    display: none !important;
  }
}
</style>
